import { Injectable } from '@angular/core';
import * as forge from 'node-forge';

/**
 * Réplica exata do EncryptionService encontrado no bundle real do portal
 * (main.df0389c59a0be610.js, portal-hml.affixtech.com.br, 21/08/2026):
 * RSA-OAEP com SHA-256, resultado em base64. O backend espera usuário/senha
 * cifrados dessa forma — mandar em texto puro faz o login sempre falhar
 * como "credenciais inválidas", mesmo com uma conta real.
 *
 * A chave pública abaixo está embutida no bundle de produção deles (visível
 * a qualquer usuário via devtools) — não é segredo, é a metade pública do
 * par usado para decifrar no servidor.
 */
@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  private readonly publicKeyPem =
    '-----BEGIN RSA PUBLIC KEY-----\n' +
    'MIIBCgKCAQEA7IHRYllGb5vDrTGyLr9B//gRbjI3q5h0po49jUZJW8k5Aq6bh/1cbFybxIdsh09S\n' +
    'ymFXIvbqDf7Tlw721waAHqOvJrWWUJ8aF7pRwG8PwGobt4wi7j6ba/OyophuP1iH62X54KT8XEfZ\n' +
    '1zdgUcxIq66xltttJGAW9+KS3Hk7MkQCqfLv8WTAbG3pMvbRwjjZwGCGN9VBoL13Mcs49uY3CNbM\n' +
    '6WuX86/qCjRQ3pD9ZPfctPYvVN1S5FIqfTzYSSMbhLG8M0d+4IHmbjlBQNAe4LRxGpX3nsKPSzQ8\n' +
    'IXXmLM1QRsKqk+nQ0rZKQn+shgXltKlt+0jX7y+coWHSigeV3QIDAQAB\n' +
    '-----END RSA PUBLIC KEY-----';

  encrypt(value: string): string {
    if (!value) {
      return '';
    }
    const encrypted = forge.pki.publicKeyFromPem(this.publicKeyPem).encrypt(value, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
    });
    return forge.util.encode64(encrypted);
  }
}
